import apiV3 from './secondStepApi.v3'
import apiV4 from './secondStepApi.v4'
import { isFlagOn } from 'utils/featureFlags'

const FEATURE_FLAG_NAME = 'feature_LEARN-24754_educator_journey_updates'

// Allowlist (current). Will switch to Exclude-list in rollout step 2.
const V4_ALLOWLIST = new Set([
  'getNetSuiteAssetsForUser',
  'getUserSites',
  'getUserLicenses',
  'getUserContext',
  'getUserAccess',
  'getUserProfile',
  'getValidatePak',
  'getValidateAccessCode',
  'postAccessCode',
  'postPakNumber',
  'updateSitePreferences',
  'updateSiteUserPreferences',
  'updateSitePacingDates',
  'updateMspOptInSettings',
])

export const isV4Routed = name => {
  if (name === 'getUserProfile') {
    return true
  }
  const isAllowListed = V4_ALLOWLIST.has(name)
  const flagIsOn = isFlagOn([FEATURE_FLAG_NAME])
  return flagIsOn && isAllowListed
}

const buildRouter = () => {
  const router = {}
  const keys = Array.from(
    new Set([...Object.keys(apiV3), ...Object.keys(apiV4)]),
  )

  keys.forEach(name => {
    const v3Value = apiV3[name]
    const v4Value = apiV4[name]

    if (typeof v3Value !== 'function' && typeof v4Value !== 'function') {
      router[name] = v3Value !== undefined ? v3Value : v4Value
      return
    }

    router[name] = (...args) => {
      const flagIsOn = isFlagOn([FEATURE_FLAG_NAME])
      const isAllowListed = V4_ALLOWLIST.has(name)
      const useV4 = flagIsOn && isAllowListed
      const impl = useV4 ? apiV4[name] : apiV3[name]

      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.debug(
          `[secondStepApi.router] ${name} -> ${useV4 ? 'v4' : 'v3'}`,
        )
      }

      if (typeof impl !== 'function') {
        return Promise.reject(
          new Error(
            `[secondStepApi.router] Method ${name} not available in ${
              useV4 ? 'v4' : 'v3'
            }`,
          ),
        )
      }
      return impl(...args)
    }
  })

  return router
}

const api = buildRouter()
// Expose a method-specific base to allow external callers (AUTH) to build the correct base for context
// Make it dynamic (getter) so it reflects runtime LaunchDarkly state after initialization
Object.defineProperty(api, 'baseApiAddressForContext', {
  configurable: false,
  enumerable: true,
  get() {
    return isV4Routed('getUserContext')
      ? apiV4.baseApiAddress
      : apiV3.baseApiAddress
  },
})

export default api
